import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import axios from "axios";
import { ROLL_CALL_API_BASE_URL } from "../../Pereco/RollCall/RollCallConfig/RollCallConfig";
// import CommonFooter from "../../../core/common/footer/commonFooter";
import footerLogo1 from "./full logo- white.avif";
import dashboardPreview from "./Dashboardimage.jpeg";
// import logocircle from "./circle graphic (1).avif";
import crm from "./crmimg.png";
import solutionIcon from "./pereco2.png";
import visitor from "./mobile.png";
import mobile from "./calendar.png";
import attendance from "./attendenceimg.png";
// import payroll from "./payroolimg.png";
const Signin = () => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [Username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setloading] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);
  // const [flipped, setFlipped] = useState(false);
  const navigate = useNavigate();
  const route = all_routes;
  const bottomStripItems = [
    { icon: "ti ti-link", label: "Real-Time Tracking" },
    { icon: "ti ti-report", label: "Detailed Reports" },
    { icon: "ti ti-shield-check", label: "Secure & Reliable" },
  ];
  const carouselImages = [
    { src: dashboardPreview, alt: "Dashboard preview" },
    { src: dashboardPreview, alt: "CRM preview" },
    { src: dashboardPreview, alt: "Attendance preview" },
  ];
  const solutionCards = [
    {
      title: "Visitor Management",
      description:
        "Manage visitors easily with a smart Visitor Management System. Generate QR-based passes for quick and secure check-ins.",
      image: visitor,
      href: "https://www.perennialcode.in/",
      alt: "Visitor management",
    },
    {
      title: "Mobile Applications",
      description:
        "Build powerful and user-friendly mobile applications for Android and iOS with seamless business connectivity.",
      image: mobile,
      href: "https://www.perennialcode.in/",
      alt: "Mobile applications",
    },
    {
      title: "Attendance Management",
      description:
        "Track attendance and manage access with biometric, RFID, and cloud dashboards for real-time monitoring.",
      image: attendance,
      href: "https://www.perennialcode.in/crm",
      alt: "Attendance management",
    },
    {
      title: "CRM Systems",
      description:
        "Centralize customer data, automate follow-ups, and track every lead from inquiry to conversion with clarity.",
      image: crm,
      href: "https://www.perennialcode.in/crm",
      alt: "CRM systems",
    },
  ];

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setloading(true);

    try {
      const response = await axios.post(
        `${ROLL_CALL_API_BASE_URL}portal/user/login`,
        {
          username: Username,
          password: password,
        },
      );

      console.log("Login Response:", response);

      const { ResultData } = response.data;
      const { Token, IsAdmin, SuperId } = ResultData;

      if (Token && IsAdmin && SuperId) {
        sessionStorage.setItem("authToken", Token);
        sessionStorage.setItem("userData", JSON.stringify(ResultData));
        sessionStorage.setItem("superId", SuperId);

        try {
          const menuResponse = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/access/getmenu?UserId=${ResultData.UserId}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Token}`,
              },
            },
          );

          const menuData = await menuResponse.json();
          // after you get menuData from API
          if (menuData?.status && Array.isArray(menuData.ResultData)) {
            sessionStorage.setItem(
              "userMenu",
              JSON.stringify(menuData.ResultData),
            );
          }
          if (menuData?.status && Array.isArray(menuData.ResultData)) {
            const flatPermissions = {};

            const flatten = (items) => {
              items.forEach((item) => {
                // store permission only if link is valid
                if (item.link && item.link !== "#") {
                  flatPermissions[item.link] = {
                    canRead: item.canRead,
                    canWrite: item.canWrite,
                    canDelete: item.canDelete,
                    canExport: item.canExport,
                  };
                }

                // if submenu exists, recurse no matter how deep
                if (
                  Array.isArray(item.submenuItems) &&
                  item.submenuItems.length > 0
                ) {
                  flatten(item.submenuItems);
                }
              });
            };

            flatten(menuData.ResultData);

            sessionStorage.setItem(
              "rollcall-permissions",
              JSON.stringify(flatPermissions),
            );

            console.log("Saved permissions map:", flatPermissions);
          }
        } catch (err) {
          console.error("Menu API error:", err);
        }

        navigate(`/${ResultData.DefaultPath}`);
      } else {
        alert("Access denied. Only Admins can access the dashboard.");
      }
    } catch (error) {
      alert("Login failed. Please check your credentials.");
      console.error("Login error:", error);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      navigate(route.rollcalldashboard, { replace: true });
    }
  }, []);

  useEffect(() => {
    const slideTimer = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % carouselImages.length);
    }, 2200);

    return () => clearInterval(slideTimer);
  }, [carouselImages.length]);

  return (
    <>
      <div className="main-wrapper">
        <style>
          {`
          .flip-container {
            perspective: 1000px;
            width: 360px;
            margin: auto;
          }

          .flip-card {
            position: relative;
            width: 100%;
            height: 360px;
            transform-style: preserve-3d;
            transition: transform 0.3s ease;
          }

          .flip-card.flipped {
            transform: rotateY(180deg);
          }

          .face {
            position: absolute;
            width: 100%;
            height: 100%;
            backface-visibility: hidden;
            padding: 20px;
          }

          .back {
            transform: rotateY(180deg);
          }
            .carousel-fixed-height {
  height: 420px;
}

.carousel-fixed-height img {
  height: 420px;
  object-fit: cover;
}

.right-panel {
  height: 420px;
}

.right-panel .card {
  flex: 1;
}

.right-panel .card-body {
  padding: 12px;
}

.right-panel .card-text {
  font-size: 14px;
}

.main-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.signin-viewport {
  min-height: 100vh;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.signin-topbar {
  flex: 0 0 auto;
  background-color: #ffe8bf;
  display: flex;
  align-items: center;
  justify-content: between;
}

.signin-showcase {
  flex: 1;
  display: flex;
  align-items: stretch;
  min-height: 0;
  padding: 12px 0 0;
  overflow: hidden;
}

.signin-showcase .container {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.solutions-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 100%;
  max-width: none;
  padding: 0 16px;
}

.showcase-shell {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 24px;
  border-radius: 34px;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.92), rgba(227, 236, 248, 0.92)),
    url("/assets/img/Dashboardimage.jpeg");
  background-size: cover;
  background-position: center;
  box-shadow: 0 26px 60px rgba(30, 54, 95, 0.12);
}

.showcase-kicker {
  margin: 0 0 10px;
  color: #bc1615;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.showcase-layout {
  display: grid;
  grid-template-columns: minmax(420px, 1.2fr) minmax(620px, 1fr);
  gap: 22px;
  flex: 1;
  min-height: 0;
}

.showcase-promo {
  display: flex;
  min-height: 0;
}

.showcase-promo-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.65);
}

.showcase-promo-visual {
  flex: 1;
  min-height: 420px;
  height: 100%;
  border-radius: 28px;
  overflow: hidden;
  background: linear-gradient(120deg, #0b1f45 0%, #2567d8 100%);
  display: flex;
  position: relative;
}

.showcase-carousel {
  width: 100%;
  height: 100%;
  position: relative;
}

.showcase-carousel-item {
  position: absolute;
  inset: 0;
  background: linear-gradient(120deg, #0b1f45 0%, #2567d8 100%);
  opacity: 0;
  transition: opacity 0.6s ease;
  pointer-events: none;
}

.showcase-carousel-item.is-active {
  opacity: 1;
  pointer-events: auto;
}

.showcase-promo-image-wrap {
  width: 100%;
  height: 100%;
}

.showcase-promo-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.showcase-center {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.solutions-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.solutions-heading-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.solutions-heading-title {
  margin: 0;
  color: #bc1615;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.solutions-heading-subtitle {
  margin: 0;
  color: #4c4c4c;
  font-size: 0.8rem;
}

.solutions-layout {
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.solutions-cards-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-auto-rows: minmax(0, 1fr);
  gap: 10px;
  width: 100%;
  height: 100%;
}

.solutions-card {
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 18px 40px rgba(36, 67, 111, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.solutions-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 40px rgba(188, 22, 21, 0.12);
}

.solutions-card-link {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  height: 100%;
  padding: 18px;
  text-decoration: none;
}

.solutions-card-icon-wrap {
  width: 86px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  background: linear-gradient(180deg, #f7f9ff 0%, #eef3ff 100%);
  flex-shrink: 0;
}

.solutions-card-icon {
  width: 56px;
  height: 56px;
  object-fit: contain;
}

.solutions-card-title {
  margin-bottom: 4px;
  color: #1d3e73;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.2;
}

.solutions-card-text {
  margin: 0;
  color: #222;
  font-size: 0.78rem;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.solutions-card-body {
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: column;
}

.solutions-card-main {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 1;
}

.solutions-card-copy {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.solutions-card-arrow {
  margin-top: auto;
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  color: #2567d8;
  font-size: 1rem;
  font-weight: 700;
}

.signin-footer {
  margin-top: 10px;
}

.signin-footer-main {
  padding: 40px 0 18px;
  background: linear-gradient(135deg, #bc1615, #e44c0a);
}

.signin-footer-grid {
  align-items: flex-start;
  row-gap: 24px;
}

.signin-footer-brand {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.signin-footer-logo {
  max-width: 240px;
}

.signin-footer-social {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.signin-footer-social a,
.signin-footer-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.signin-footer-social a {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  color: #fff;
  background: rgba(255, 255, 255, 0.14);
  text-decoration: none;
}

.signin-footer-address {
  display: inline-flex;
  align-items: flex-start;
  gap: 12px;
  color: #fff;
  text-decoration: none;
  line-height: 1.5;
}

.signin-footer-content {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 24px;
}

.signin-footer-title {
  margin: 0 0 12px;
  font-size: 1.1rem;
  font-weight: 700;
}

.signin-footer-contact {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.signin-footer-line {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0;
  line-height: 1.5;
}

.signin-footer-email-list,
.signin-footer-links {
  margin: 0;
  padding: 0;
  list-style: none;
}

.signin-footer-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.signin-footer-links a {
  color: #fff;
  text-decoration: none;
}

.signin-footer-divider {
  margin: 24px 0 12px;
}

.signin-footer-copy {
  text-align: center;
  font-size: 0.85rem;
}
   .rollcall-highlight-strip,
          .rollcall-bottom-strip {
          margin-top: 15px;
            display: grid;
            align-items: center;
            gap: 12px;
            border-radius: 18px;
            background: rgba(255, 255, 255, 0.64);
            border: 1px solid rgba(208, 223, 247, 0.86);
            box-shadow: 0 16px 30px rgba(74, 109, 173, 0.08);
          }

          .rollcall-highlight-strip {
            grid-template-columns: repeat(3, minmax(0, 1fr));
            padding: 14px 18px;
          }

          .rollcall-bottom-strip {
            grid-template-columns: repeat(3, minmax(0, 1fr));
            margin-top: 0;
            padding: 12px 18px;
          }

          .rollcall-strip-item {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 2px;
            color: #17335c;
            font-size: 13px;
            text-align: center;
          }

          .rollcall-strip-item i {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: rgba(38, 117, 246, 0.12);
            color: #1f5ec9;
            font-size: 15px;
          }


@media (max-width: 991.98px) {
  .signin-viewport {
    height: auto;
    min-height: 100vh;
  }

  .signin-showcase {
    overflow: visible;
    padding-bottom: 16px;
  }

  .solutions-cards-grid {
    height: auto;
    grid-auto-rows: auto;
  }

  .signin-footer-content {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .showcase-head {
    flex-direction: column;
  }

  .showcase-meta {
    justify-content: flex-start;
  }

  .showcase-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767.98px) {
  .solutions-section {
    padding: 0 12px;
  }

  .showcase-shell {
    padding: 18px;
    border-radius: 24px;
  }

  .solutions-cards-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-height: 820px) {
  .signin-viewport {
    height: auto;
  }

  .signin-showcase {
    overflow: visible;
  }

  .solutions-cards-grid {
    height: auto;
    grid-auto-rows: auto;
  }
}
        `}
        </style>
        <div className="signin-viewport">
          <div id="about" className="pb-3 signin-topbar">
            <div className="container">
              <div className="row align-items-center text-start pt-3 justify-content-between">
                <div className="col-md-2 text-center fade-left">
                  <ImageWithBasePath
                    src="assets/img/logo.png"
                    alt="img"
                    className="img-fluid rounded-end"
                  />
                </div>
                <div className="col-md-7 d-flex align-items-center me-1">
                  <form
                    className="d-flex align-items-center gap-2 ms-auto"
                    onSubmit={handleLogin}
                  >
                    <div className="">
                      <div className="input-group">
                        <input
                          type="text"
                          placeholder="Enter UserName"
                          className="form-control border-end-0"
                          value={Username}
                          id="floatingEmail"
                          onChange={(e) => setUserName(e.target.value)}
                        />
                        <span className="input-group-text border-start-0">
                          <i className="ti ti-mail" />
                        </span>
                      </div>
                    </div>

                    <div className="">
                      <div className="pass-group">
                        <input
                          type={isPasswordVisible ? "text" : "password"}
                          className="pass-input form-control"
                          placeholder="Enter Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <span
                          className={`ti toggle-password ${
                            isPasswordVisible ? "ti-eye" : "ti-eye-off"
                          }`}
                          style={{ color: "#1c1a1a" }}
                          onClick={togglePasswordVisibility}
                        ></span>
                      </div>
                    </div>
                    <div className="form-login">
                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={loading}
                      >
                        {loading ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                          ></span>
                        ) : (
                          "Sign In"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="account-content signin-showcase">
            <div className="login-wrappe my-0 container-fluid solutions-section">
              <div className="showcase-shell">
                <div className="showcase-layout">
                  <div className="showcase-promo">
                    <div className="showcase-promo-card">
                      <div className="showcase-promo-visual">
                        <div className="showcase-carousel">
                          {carouselImages.map((image, index) => (
                            <div
                              key={image.alt}
                              className={`showcase-carousel-item ${index === activeSlide ? "is-active" : ""}`}
                            >
                              <div className="showcase-promo-image-wrap">
                                <img
                                  className="showcase-promo-image"
                                  src={image.src}
                                  alt={image.alt}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="showcase-center">
                    <div className="solutions-heading">
                      <img
                        src={solutionIcon}
                        alt="solutions"
                        className="solutions-heading-icon"
                      />
                      <p className="solutions-heading-title">
                        Solutions We Offer
                      </p>
                      <h6 className="solutions-heading-subtitle">
                        Tailored digital solutions
                      </h6>
                    </div>
                    <div className="solutions-layout">
                      <div className="solutions-cards-grid">
                        {solutionCards.map((card) => (
                          <div
                            key={card.title}
                            className="card solutions-card d-flex flex-column align-items-center fade-up text-center"
                          >
                            <a
                              href={card.href}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="solutions-card-link"
                            >
                              <div className="card-body p-0 solutions-card-body">
                                <div className="solutions-card-main">
                                  <div className="solutions-card-icon-wrap">
                                    <img
                                      src={card.image}
                                      className="solutions-card-icon hover-img"
                                      alt={card.alt}
                                    />
                                  </div>
                                  <div className="solutions-card-copy">
                                    <p className="solutions-card-title">
                                      {card.title}
                                    </p>
                                    <p className="solutions-card-text">
                                      {card.description}
                                    </p>
                                  </div>
                                </div>
                                <span className="solutions-card-arrow">
                                  <i className="ti ti-arrow-right" />
                                </span>
                              </div>
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="rollcall-bottom-strip mt-3">
                      {bottomStripItems.map((item) => (
                        <div key={item.label} className="rollcall-strip-item">
                          <i className={item.icon} />
                          <span>{item.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="signin-footer">
          <footer className="bg-dark text-white signin-footer-main">
            <div className="container">
              <div className="row signin-footer-grid">
                <div className="col-lg-5 col-md-6 text-start overview-text">
                  <div className="signin-footer-brand">
                    <img
                      src={footerLogo1}
                      alt=""
                      className="img-fluid signin-footer-logo"
                    />

                    <div className="signin-footer-social">
                      <a
                        href="https://www.instagram.com/pereco_india/?igsh=MXFrNXRieHozMHVicA%3D%3D#"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white"
                      >
                        <i className="fa-brands fa-instagram"></i>
                      </a>
                      <a
                        href="https://www.facebook.com/Perecoindia/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white"
                      >
                        <i className="fa-brands fa-facebook"></i>
                      </a>
                      <a
                        href="https://x.com/PerecoIndia"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white"
                      >
                        <i className="fa-brands fa-x-twitter"></i>
                      </a>
                      <a
                        href="https://www.linkedin.com/company/perennial-code/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white"
                      >
                        <i className="fa-brands fa-linkedin"></i>
                      </a>
                      <a
                        href="https://www.youtube.com/@perecoindia"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white"
                      >
                        <i className="fa-brands fa-youtube"></i>
                      </a>
                    </div>

                    <a
                      href="https://www.google.com/maps/dir//opp.+ASK+Educational+Society,+Vittal+Nagar,+Adikmet,+Hyderabad,+Telangana+500044/@17.4059614,78.4262689,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bcb99a6320e26bb:0x199d77b1f4faac56!2m2!1d78.5086707!2d17.4059783?entry=ttu"
                      className="signin-footer-address"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa-solid fa-location-dot signin-footer-icon"></i>
                      <span className="text-start">
                        <span className="d-block">
                          Vidya Nagar Street Number 7,
                        </span>
                        <span className="d-block">
                          Hyderabad, Telangana, 500044
                        </span>
                      </span>
                    </a>
                  </div>
                </div>
                <div className="col-lg-7 col-md-6 overview-text">
                  <div className="signin-footer-content">
                    <div className="text-start overview-text">
                      <h4 className="signin-footer-title">Contact</h4>
                      <div className="signin-footer-contact small">
                        <p className="signin-footer-line">
                          <i className="fa-solid fa-phone signin-footer-icon"></i>
                          <span>+91 8297230010</span>
                        </p>
                        <div className="signin-footer-line">
                          <i className="fa-solid fa-envelope signin-footer-icon"></i>
                          <ul className="signin-footer-email-list overview-text">
                            <li>sales@perennialcode.in</li>
                            <li>support@perennialcode.in</li>
                            <li>info@perennialcode.in</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="text-start overview-text">
                      <h5 className="signin-footer-title">Quick Links</h5>
                      <ul className="signin-footer-links">
                        <li>
                          <a
                            href="https://www.perennialcode.in"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white text-decoration-none"
                          >
                            Home
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.perennialcode.in/aboutus"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white text-decoration-none"
                          >
                            About Us
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.perennialcode.in/solutions"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white text-decoration-none"
                          >
                            Solutions
                          </a>
                        </li>
                        {/* <li>
                          <a
                            href="https://www.perennialcode.in/casestudies"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white text-decoration-none"
                          >
                            Case Studies
                          </a>
                        </li> */}
                        <li>
                          <a
                            href="https://www.perennialcode.in/contactus"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white text-decoration-none"
                          >
                            Contact Us
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <hr className="border-light signin-footer-divider" />

              <div className="signin-footer-copy">
                &copy; 2025 Perennial Code. All Rights Reserved.
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};

export default Signin;
